export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11224.49287567.jpg";